const origin = window.location.origin;
export const prodURL = "https://kmc.wb.gov.in";
export const uatURL = "https://kmc-dev.ddns.net";
// export const uatURL = "https://kmcuat.wb.gov.in";


export const mainURL = origin.includes("localhost")
  ? uatURL
  : origin.includes("kmc-dev")
  ? "https://kmc-dev.ddns.net"
  : origin.includes("kmcuat")
  ? uatURL
  : prodURL;


 
